import Votacao from "../Votacao";

export default function Femininos() {
  return <Votacao colecao="femininos" titulo="Perfumes Femininos" />;
}
